<template>
  <div
    data-ui-section="arrow"
    :class="{
      [$style.maskCover]: true,
      [$style.left]: left,
      [$style.right]: right,
    }"
    @click="$emit('click')"
  >
    <div
      :class="{
        [$style.cover]: true,
        [externalStyle.background]: true,
        [$style.show]: show,
      }"
      :style="transformOverride"
    >
      <i
        :class="$style.arrow"
        class="material-icons"
        :data-icon="iconText"
      />
    </div>
  </div>
</template>

<script lang="ts">
import LayoutGutterStyle from '@/scripts/implementation/common-templates/styles/layout-gutter.module.scss';
import Vue, { PropType } from 'vue';

export default Vue.extend({
  props: {
    left: {
      type: Boolean,
      default: false,
    },
    right: {
      type: Boolean,
      default: false,
    },
    show: {
      type: Boolean,
      default: true,
    },
    externalStyle: {
      type: Object as PropType<Record<string, string | undefined>>,
      default: (): any => ({}),
    },
  },
  data() {
    return {
      LayoutGutterStyle,
      transformOverride: {} as Record<string, string>,
    };
  },
  computed: {
    iconText(): string {
      if (this.left) {
        return 'chevron_left';
      }
      if (this.right) {
        return 'chevron_right';
      }
      return '';
    },
  },

  mounted() {
    window.addEventListener('resize', this.handleResize);
    this.handleResize();
  },

  destroyed() {
    window.removeEventListener('resize', this.handleResize);
  },

  methods: {
    handleResize(): void {
      const { left, right } = this.$el.getBoundingClientRect();
      const clientWidth = this.$el.clientWidth;

      if (this.left) {
        const projectedTranslationX = left;
        const idealTranslationX = Math.min(clientWidth, projectedTranslationX);

        this.transformOverride = {
          transform: `translateX(${-idealTranslationX}px)`,
        };
      } else if (this.right) {
        const projectedTranslationX = document.body.clientWidth - right;
        const idealTranslationX = Math.min(clientWidth, projectedTranslationX);

        this.transformOverride = {
          transform: `translateX(${idealTranslationX}px)`,
        };
      }
    },
  },
});
</script>

<style lang="scss" module>
@import '~@/stylesheets/exports/_component-entry';
@import '~@/scripts/implementation/common-templates/styles/layout-gutter.utilities';

$size: 3em;
$padding: 2em;

.maskCover {
  position: absolute;
  top: 0;
  height: 100%;
  z-index: 1;

  $shadow-allowance: 8px;

  display: none;
  @include gutter-breakpoint-up(sm) {
    display: flex;
  }
  justify-content: center;
  align-items: center;

  cursor: pointer;
  user-select: none;

  min-width: $size + $padding * 2;
  .arrow {
    font-size: $size;
    color: $primary;
    color: get-hsl-var-value(primary);

    background-color: white;
    border-radius: 99em;
    box-shadow: 4px 4px 16px 0 rgba(black, 0.15);
  }
}

.cover {
  $shadow-allowance: 4px;
  width: calc(100% - #{$shadow-allowance});
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  opacity: 1;

  padding-left: $padding;
  padding-right: $padding;
}

// Interaction behaviour
.maskCover {
  pointer-events: none;
}
.cover {
  transition: opacity 0.5s;
  pointer-events: none;
  animation: interactionPassthrough 1.2s step-end;

  .arrow {
    transition: opacity 0.5s;
    opacity: 0;
  }

  &.show {
    pointer-events: auto;
    animation: interactionCapture 0.1s step-start;
    .arrow {
      opacity: 1;
    }
  }

  @keyframes interactionPassthrough {
    0% { pointer-events: auto; }
    100% { pointer-events: none; }
  }
  @keyframes interactionCapture {
    0% { pointer-events: none; }
    100% { pointer-events: auto; }
  }
}

// UI Positioning
.maskCover.left {
  left: 0px;
  .cover {
    margin-right: auto;
  }
}
.maskCover.right {
  right: 0px;
  .cover {
    margin-left: auto;
  }
}

:global(.gutter) :local {
  .maskCover.left {
    .cover {
      justify-content: flex-end;
    }
  }
  .maskCover.right {
    .cover {
      justify-content: flex-start;
    }
  }
}
</style>
